<template>
    <div class="page-content">

        <div class="modal-header">
            <h4 class="modal-title">
                Select Creation Type
            </h4>
        </div>
        <div class="d-flex flex-column w-100 mb-5">
            <!-- Tabs -->
            <div class="d-flex w-50 justify-content-between border-bottom">
                <button @click="activeTab = 'bulk'" :class="['tab-btn', activeTab === 'bulk' ? 'active-tab' : '']">
                    Bulk Invoices
                </button>
                <button @click="activeTab = 'single'" :class="['tab-btn', activeTab === 'single' ? 'active-tab' : '']">
                    Single Invoice
                </button>
            </div>
        </div>

        <div v-if="activeTab === 'bulk'" class="bulk-invoice-container d-flex align-items-center flex-wrap">
            <!-- <i class="fa-solid fa-circle-info opacity-50" data-bs-toggle="tooltip" data-bs-placement="top"
                title="Page shows Current month data by default. Please select the desired date for records."></i> -->

            <div class="py-2 px-3 my-3"
                style="background-color: whitesmoke; font-weight: 500; border-radius: 20px;width:100%;max-width: 245px;box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);">
                {{ formatDate(fromDate) }} to {{ formatDate(toDate) }}
            </div>

            <!-- Generate Button -->
            <div class="top_heading_CreatePartner_btn">
                <button class="btn btn-primary fw-bold d-flex align-items-center px-4 py-2" type="button"
                    @click="generateBulkInvoices()">
                    <i class="fa-solid fa-plus me-1"></i> <span class="fs-5">Generate Bulk Invoices</span>
                </button>
            </div>
            <!-- calendar icon -->
            <span v-if="activeTab === 'bulk'"
                class="top_heading_CreatePartner_btn d-block d-flex align-items-center float-end">
                <div class="Group_top_three_dot">
                    <div class="dropdown">
                        <button class="btn p-0 Group_top_three_dot_dropdown" type="button">
                            <img src="../../../public/dashboard-assets/images/M2/date-icon.png" @click="opencal"
                                data-bs-toggle="tooltip" data-bs-placement="top" title="Filter by Date" />
                            <span class="cal-alert translate-middle" v-if="fromDate">
                                <span class="visually-hidden"></span>
                            </span>
                            <input type="text" name="daterange" hidden id="calendar_icon" class="fade" />
                        </button>
                    </div>
                </div>
            </span>

        </div>
        
        <form @submit.prevent="AddInvoice" v-if="activeTab === 'single'">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            Select Company
                        </span>
                        <vue3-select style="width: 100%;" v-model="selectedPartner" :options="clientsList" label="label"
                            placeholder="Select an option" @update:modelValue="updateClientId()" required
                            class="mb-2" />
                    </label>
                </div>
                <div class="col-md-6">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            Select User ID
                        </span>
                        <vue3-select style="width: 100%;" v-model="this.selectedUserId" :options="this.userIds"
                            label="label" placeholder="Select an option" class="mb-2" required />
                    </label>
                </div>
                <div class="col-md-6 mb-3">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            Invoice No.
                        </span>
                        <input type="text" v-model="invoiceNumber" class="form-control" required
                            @input="validateInvoiceNo" placeholder="Enter Invoice No.">
                        <span v-if="invoiceError" class="text-danger">{{ invoiceError
                        }}<br></span>
                    </label>
                </div>
                <div class="col-md-6">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            From Date
                        </span>
                        <input type="date" v-model="fromDate" class="form-control" :max="maxDateTime" required>
                    </label>
                </div>
                <div class="col-md-6 mb-3">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            To Date
                        </span>
                        <input type="date" v-model="toDate" class="form-control" :max="maxDateTime" required>
                    </label>
                </div>

                <div class="col-md-6">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            Region ID
                        </span>
                        <input type="text" v-model="regionId" class="form-control" required @input="validateRegionId">
                        <span v-if="regionError" class="text-danger">{{ regionError }}<br></span>
                    </label>
                </div>
                <div class="col-md-6 mb-3">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            Test ID
                        </span>
                        <input type="text" v-model="testId" class="form-control" required @input="validateTestId">
                        <span v-if="testError" class="text-danger">{{ testError }}<br></span>
                    </label>
                </div>

                <div class="col-md-6">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            Created Date
                        </span>
                        <input type="date" v-model="createdDate" class="form-control" required :max="maxDateTime">
                    </label>
                </div>

                <div class="col-md-6">
                    <label class="input-hero w-100">
                        <span class="input-name">
                            Draft
                        </span>
                        <vue3-select style="width: 100%;" v-model="this.isDraft" :options="this.isDraftOptions"
                            label="label" placeholder="Select an option" class="mb-2" required />
                    </label>
                </div>
            </div>

            <!-- select dropdown for partners -->
            <div class="text-end mt-4">
                <button type="button" class="btn me-2" :class="'secondary-button'" data-bs-dismiss="modal"
                    @click="clearInputs()">
                    Clear
                </button>
                <button type="submit" class="btn btn-primary">
                    Submit
                </button>
            </div>
        </form>

    </div>


</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import "vue3-select/dist/vue3-select.css";
import Vue3Select from "vue3-select";

export default {
    name: "CreateInvoices",
    components: {
        Vue3Select,
    },
    data() {
        return {
            fromDate: moment().startOf('month').format("YYYY-MM-DD 00:00:00"),
            toDate: moment().endOf('month').format("YYYY-MM-DD 23:59:59"),
            invoices: [],
            clientsList: [],
            selectedPartner: null,
            selectedUserId: null,
            selectedClientId: null,
            invoiceUserObject: null,
            userIds: [],
            invoiceNumber: "",
            regionId: 0,
            testId: 0,
            createdDate: "",
            isDraft: null,
            isDraftOptions: [true,false],

            //for validation
            invoiceError: '',
            regionError: '',
            testError: '',

            //for tabs
            activeTab: 'bulk', 

            maxDateTime: new Date().toISOString().slice(0, 10),
        }
    },
    methods: {
        opencal() {
            this.initializeDatePicker();
            document.getElementById("calendar_icon").click();
        },
        formatDate(date) {
            return moment(date).format("DD-MM-YYYY");
        },
        ...mapActions(["GetBulkInvoicesByDate", "SendBulkInvoicesByDate", "GetClientsByInvoiceType",
            "GetInvoiceUserById", "PostSingleInvoice", "ShowErrorMessage", "ShowWarningMessage"]),
        async fetchBulkInvoices() {
            const response = await this.GetBulkInvoicesByDate({
                fromDate: this.fromDate,
                toDate: this.toDate
            });
            this.invoices = response.object.data;
        },
        async generateBulkInvoices() {
           await this.SendBulkInvoicesByDate({
                fromDate: this.fromDate,
                toDate: this.toDate
            });
        },
        async PartnerList() {
            var clients = await this.GetClientsByInvoiceType();

            this.clientsList = clients?.object?.data?.map((i) => ({
                value: i.clientId,
                label: i.clientId + ' - ' + i.company,
            }));
        },
        async updateClientId() {
            this.selectedUserId = null
            if (this.selectedPartner) {
                this.selectedClientId = this.selectedPartner.value;
                this.invoiceUserObject = await this.GetInvoiceUserById({
                    clientId: this.selectedClientId
                });
                this.userIds = this.invoiceUserObject.object.data.map(x => x.id)

            } else {
                this.selectedClientId = null;
                this.invoiceUserObject = null;
            }
        },
        async AddInvoice() {
            this.validateInvoiceNo();
            this.validateRegionId();
            this.validateTestId();
            const date = new Date();
            if (this.invoiceError || this.regionError || this.testError){
                return this.ShowErrorMessage("Field inputs were incorrect, Try Again!!");
            }
            else if (this.fromDate >= this.toDate){
                return this.ShowWarningMessage("From Date can't be greater than To Date");
            }
            else if (this.fromDate > date || this.toDate > date){
                return this.ShowWarningMessage("Date can't be greater than Current Date");
            }
            else if (this.fromDate < '2000-01-01'){
                return this.ShowWarningMessage("From Date should be after the year 2000");
            } 
            else if(this.toDate > '2050-01-01') {
                return this.ShowWarningMessage("To Date should be before the year 2050");
            }
            
            try {
                await this.PostSingleInvoice({
                    invoiceNumber: this.invoiceNumber,
                    clientId: this.selectedClientId,
                    userId: this.selectedUserId,
                    testId: this.testId,
                    regionId: this.regionId,
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    createdDate: this.createdDate,
                    isDraft: this.isDraft
                } 
            );
            } catch (error) {
                console.log(error)
            }
        },
        validateInvoiceNo() {
            const pattern = /^[A-Z]{3}-[A-Z]{2}$/;
            this.invoiceError = pattern.test(this.invoiceNumber) ? '' : 'Format: ABC-DE (Only uppercase letters)';
        },
        validateRegionId() {
            const pattern = /^[0-9,]+$/;
            this.regionError = pattern.test(this.regionId) ? '' : 'Only numbers and commas are allowed';
        },
        validateTestId() {
            const pattern = /^[0-9]+$/;
            this.testError = pattern.test(this.testId) ? '' : 'Only numbers are allowed';
        },
        clearInputs() {
            this.selectedPartner = null
            this.selectedUserId = null
            this.invoiceNumber = null
            this.regionId = 0
            this.testId = 0
            this.createdDate = null
        },
        async initializeDatePicker(){
            window.$('input[name="daterange"]').daterangepicker(
            {
                maxDate: new Date(),
                locale: { cancelLabel: "Clear" },
                opens: "center",
            },
            (start, end) => {
                if (start && end) {
                    this.fromDate = start.format("YYYY-MM-DD 00:00:00");
                    this.toDate = end.format("YYYY-MM-DD 23:59:59");
                }
            }
        );
        window
            .$('input[name="daterange"]')
            .on("cancel.daterangepicker", (ev, picker) => {
                picker.startDate._d = new Date();
                picker.endDate._d = new Date();
                this.fromDate = this.dateformat(
                    new Date(new Date().setMonth(new Date().getMonth() - 6))
                ),
                    this.toDate = this.todateformat(new Date(new Date())),
                    window.$('input[name="daterange"]').val("");
            });
        window
            .$('input[name="daterange"]')
            .on("apply.daterangepicker", async (ev, picker) => {
                var x = moment(String(picker.startDate._d)).format("YYYY-MM-DD 00:00:00");
                var y = moment(String(picker.endDate._d)).format("YYYY-MM-DD 23:59:59");
                var start = moment(String(picker.startDate._d)).format("YYYY-MM-DD 00:00:00")
                var end = moment(String(picker.endDate._d)).format("YYYY-MM-DD 23:59:59")
                if (
                    Math.ceil(
                        Math.abs(new Date(start) - new Date(end)) /
                        (1000 * 60 * 60 * 24)
                    ) <= 180
                ) {
                    this.fromDate = x;
                    this.toDate = y;
                } else {
                    return this.ShowWarningMessage("Please select range within 6 months");
                }
            });
        }

    },
    async mounted() {
        this.PartnerList();
    },
}
</script>

<style scoped>
.daterangepicker {
    display: block !important;
}

.tab-btn {
    width: 50%;
    padding: 10px;
    background: none;
    border: none;
    color: gray;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    outline: none;
    transition: all 0.3s ease-in-out;
}

.tab-btn:hover {
    color: black;
}

.active-tab {
    color: black;
    font-weight: bold;
    border-bottom: 4px solid yellow;
}

.bulk-invoice-container {
    display: flex;
    gap: 15px;
    /* align-items: center;
  justify-content: start;
  flex-wrap: wrap; */
}

/* Responsive Design */
@media (max-width: 768px) {
    .tab-btn {
        font-size: 14px;
        padding: 8px;
    }

    .bulk-invoice-container {
        flex-direction: column;
        align-items: flex-start;
    }
}

.secondary-button {
    /* background-color: #FFFFFF; */
    font-size: medium !important;
    font-weight: 600;
    border-radius: 4px;
    color: #7b68ee;
    border: 2px solid #7b68ee !important;
    /* width: 100%; */
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
    cursor: pointer;
}

@media (max-width: 576px) { 
    .top_heading_CreatePartner_btn {
        display: flex !important;
        justify-content: center;
    }

    .top_heading_CreatePartner_btn button {
        width: 100%; 
        max-width: 300px; 
        font-size: 14px; 
        padding: 10px 12px;
    }
}
</style>